import { useEffect, useState } from "react";

type LiveStatConfig = {
  seedValue: number;
  perSecond: number;
  /** Epoch ms the seed was measured at; defaults to mount time. */
  seedTimeMs?: number | undefined;
};

// Ticks exactly when the next whole increment lands, mirroring the retired
// LiveCleaningTracker scheduling.

export const useLiveStat = ({
  seedValue,
  perSecond,
  seedTimeMs,
}: LiveStatConfig): number => {
  const [value, setValue] = useState(seedValue);

  useEffect(() => {
    if (perSecond <= 0) {
      return;
    }
    const startMs = seedTimeMs ?? Date.now();
    const incrementMs = 1000 / perSecond;
    let timeoutId: number | undefined;

    const update = () => {
      const elapsedMs = Math.max(0, Date.now() - startMs);
      setValue(seedValue + Math.floor(elapsedMs / incrementMs));
      timeoutId = window.setTimeout(
        update,
        incrementMs - (elapsedMs % incrementMs),
      );
    };
    update();

    return () => {
      if (timeoutId !== undefined) {
        window.clearTimeout(timeoutId);
      }
    };
  }, [perSecond, seedTimeMs, seedValue]);

  return value;
};
